import { render, staticRenderFns } from "./Commit.vue?vue&type=template&id=586ba5d3&scoped=true"
import script from "./Commit.vue?vue&type=script&lang=js"
export * from "./Commit.vue?vue&type=script&lang=js"
import style0 from "./Commit.vue?vue&type=style&index=0&id=586ba5d3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "586ba5d3",
  null
  
)

export default component.exports